export const getHeaderAttributes = () => {
  const languageToTranslate = localStorage.getItem("language") || "it";
  const actualLang = languageToTranslate === "it" ? "lc" : languageToTranslate;

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    lang: actualLang,
  };
};

export default getHeaderAttributes;
